import "../styles/Shop.css";
import { useEffect, useState, useMemo, useContext, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { FaArrowDown, FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { FaRegHeart, FaHeart } from "react-icons/fa";

import { getCategoryProductList } from "../services/apiService";
import noimage from "../assets/noimage.webp";
import { CartContext } from "../contextApi/CartContext";
import { showSnackbar } from "../comopnents/snackbar";

import {
  AddItemToWishList,
  AddItemToCart,
  DeleteFromWishList,
  getProductQty,
} from "../services/Cart";
import AuthModal from "../comopnents/AuthModal";
import { Notifyed } from "../services/Auth";
import CartQuantityControl from "../comopnents/CartQuantityControl";
import PurchaseOptionsModal from "../comopnents/PurchaseOptionsModal";
import { useAuthGuard } from "../comopnents/useAuthGuard";
import {
  buildCartPurchaseData,
  buildEnhancedPurchaseData,
  getMinOrderQty,
  getMinimumPurchaseQuantity,
  getPurchaseQuantityStep,
  getSavedCartPurchaseData,
  shouldShowPurchaseModal,
} from "../utils/purchaseOptions";
import { isOutOfStock } from "../utils/stock";

function ShopByCategory() {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const { requireAuth, authModal } = useAuthGuard();
  const [searchParams] = useSearchParams();
  const categoryFromUrl = searchParams.get("category");
  const navigate = useNavigate();
  const productGridRef = useRef(null);

  const { addToCart, itemList, setCartQty } = useContext(CartContext);

  /* ================= STATE ================= */
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [pendingPurchaseProduct, setPendingPurchaseProduct] = useState(null);
 const [maxPrice, setMaxPrice] = useState(0);
  const [priceLimit, setPriceLimit] = useState(0);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [minDiscount, setMinDiscount] = useState(0)
  const [filteredMaxPrice, setFilteredMaxPrice] = useState(0);
  /* Wishlist state: { productid: true } */
  const [wishlist, setWishlist] = useState({});

  /* ================= LOAD PRODUCTS ================= */
  useEffect(() => {
    if (categoryFromUrl) {
      loadProducts(categoryFromUrl);
    }
  }, [categoryFromUrl]);

  const loadProducts = async (category) => {
    try {
      setLoading(true);
      const res = await getCategoryProductList(category);
      setProducts(res?.data || []);
    } catch (error) {
      console.error("Category load error:", error);
    } finally {
      setLoading(false);
    }
  };

   const uniqueBrands = useMemo(() => {
    let result = [...products];

    if (selectedCategory) {
      result = result.filter((p) => p.category === selectedCategory);
    }

    if (selectedModels.length) {
      result = result.filter((p) =>
        selectedModels.includes(p.modelno || p.displaymodelno),
      );
    }

    return [...new Set(result.map((p) => p.brand).filter(Boolean))];
  }, [products, selectedCategory, selectedModels]);

 

  // ----- Calculate Categories & Models -----
  const categories = useMemo(() => {
    const map = {};
    products.forEach((p) => {
      if (!map[p.category]) map[p.category] = 0;
      map[p.category]++;
    });
    return Object.keys(map).map((k) => ({ name: k, count: map[k] }));
  }, [products]);

  const models = useMemo(() => {
    const map = {};
    products.forEach((p) => {
      const model = p.modelno || p.displaymodelno;
      if (!map[model]) map[model] = 0;
      map[model]++;
    });
    return Object.keys(map).map((k) => ({ name: k, count: map[k] }));
  }, [products]);

  /* ================= ADD TO WISHLIST ================= */
  const handleAddToWishList = async (productid) => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      showSnackbar("error", "Please login to add wishlist");
      return;
    }

    if (wishlist[productid]) {
      showSnackbar("info", "Item already in wishlist");
      return;
    }

    try {
      await AddItemToWishList({
        productid,
        customerid: userId,
      });

      setWishlist((prev) => ({
        ...prev,
        [productid]: true,
      }));

      showSnackbar("success", "Item added to Wishlist!");
    } catch (error) {
      console.error("Add to wishlist error:", error);
      showSnackbar("error", "Failed to add item to Wishlist");
    }
  };

   const handleNotifyMe = async (productid) => {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        if (!requireAuth(() => handleNotifyMe(productid))) return;
        return;
      }
      try {
        const response = await Notifyed({
          customerid: userId,
          productid: productid,
        });
  
        console.log("Notify me success:", response);
        showSnackbar("success", "We will notify you when product is available");
      } catch (error) {
        console.error("Notify me error:", error.response?.data || error.message);
        showSnackbar("error", "Failed to register notify request");
      }
    };
  /* ================= REMOVE FROM WISHLIST ================= */
  const handleDeleteWishList = async (productid) => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;

    try {
      await DeleteFromWishList({
        customerid: userId,
        productid,
      });

      setWishlist((prev) => ({
        ...prev,
        [productid]: false,
      }));
      showSnackbar("success", "Item removed from Wishlist");
    } catch (error) {
      console.error("Delete wishlist error:", error);
      showSnackbar("error", "Failed to remove item from Wishlist");
    }
  };

  useEffect(() => {
    let result = [...products];

    if (selectedCategory) {
      result = result.filter((p) => p.category === selectedCategory);
    }

    if (selectedModels.length) {
      result = result.filter((p) =>
        selectedModels.includes(p.modelno || p.displaymodelno),
      );
    }
     if (minDiscount > 0) {
    result = result.filter((p) => (p.discount || 0) >= minDiscount);
  }
    // ✅ Brand filter (NEW)
    if (selectedBrands.length) {
      result = result.filter((p) => selectedBrands.includes(p.brand));
    }

    result = result.filter((p) => {
      let price = p.mrp;
      if (p.discount) price = price - (price * p.discount) / 100;
      return price <= maxPrice;
    });

    setFilteredProducts(result);

    const filteredMax = result
      ? Math.max(
        ...result.map((p) => {
          let price = p.mrp;
          if (p.discount) price = price - (p.discount * price) / 100;
          return price;
        }),
      )
      : 0;
    setFilteredMaxPrice(filteredMax);
      }, [products, selectedCategory, selectedModels, maxPrice, selectedBrands,minDiscount]);

  const openPurchaseModal = (product) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setPendingCartId({ product });
      setShowAuthModal(true);
      return;
    }

    if (!shouldShowPurchaseModal(product)) {
      const purchaseData = buildCartPurchaseData(product, "piece");
      handleAddToCart(product, purchaseData.quantity, purchaseData);
      return;
    }
    setPendingPurchaseProduct(product);
    setShowPurchaseModal(true);
  };

  const confirmPurchaseType = async (purchaseType, couponData) => {
    if (!pendingPurchaseProduct) return;
    const purchaseData = buildEnhancedPurchaseData(pendingPurchaseProduct, purchaseType, couponData);
    await handleAddToCart(pendingPurchaseProduct, purchaseData.quantity, purchaseData);
    setShowPurchaseModal(false);
    setPendingPurchaseProduct(null);
  };

  /* ================= ADD TO CART ================= */
  const handleAddToCart = async (product, qty, purchaseData = null) => {
    const productid = product?.productid || product;
    if (isOutOfStock(product)) {
      await handleNotifyMe(productid);
      return;
    }

    if (!requireAuth(() => handleAddToCart(product, qty, purchaseData))) return;

    const userId = localStorage.getItem("userId");
    try {
      await AddItemToCart({
        customerid: userId,
        productid,
        qty,
        stock: product?.stock,
      });

      addToCart(productid, qty, purchaseData);
      showSnackbar("success", "Item Added to Cart!");
    } catch (error) {
      console.error("Add to cart error:", error);
      showSnackbar("error", "Failed to add item to cart");
    }
  };

  const handleCartQtyChange = async (productid, qty) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      if (!requireAuth(() => handleCartQtyChange(productid, qty))) return;
      return;
    }

    try {
      await getProductQty({ user_id: userId, productid, qty });
      setCartQty(productid, qty);
    } catch (error) {
      console.error("API Error:", error?.message || error);
      showSnackbar("error", "Failed to update quantity");
    }
  };

  // ----- Display Max Price -----
  const displayMaxPrice = useMemo(() => {
    if (!filteredProducts.length) return 0;
    return Math.max(
      ...filteredProducts.map((p) => {
        let price = p.mrp;
        if (p.discount) price = price - (p.discount * price) / 100;
        return price;
      }),
    );
  }, [filteredProducts]);
  /* ================= PRICE FILTER INIT ================= */
  useEffect(() => {
    if (products.length > 0) {
      const maxMRP = Math.max(...products.map((p) => Number(p.mrp || 0)));
      setMaxPrice(maxMRP);
      setPriceLimit(maxMRP);
    }
  }, [products]);

  const goToProductDetail = (id) => {
    navigate(`/productdetail?productid=${id}`);
  };

  /* ================= SCROLL FUNCTIONS ================= */
  const scrollLeft = () => {
    if (productGridRef.current) {
      productGridRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };

  const scrollRight = () => {
    if (productGridRef.current) {
      productGridRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };

  /* ================= RENDER ================= */
  return (
    <div className="shop-container">
      {/* FILTERS */}
     <div className="filters">
          <h3>Product Categories</h3>
          <ul className="category-list">
            {categories.map((c, i) => (
              <li
                key={i}
                className={selectedCategory === c.name ? "active" : ""}
                onClick={() => setSelectedCategory(c.name)}
              >
                <span>{c.name}</span>
                <span className="category-count">({c.count})</span>
              </li>
            ))}
          </ul>

          <div className="price-filter">
            <h4>Filter By Price</h4>
            <div className="price-range">
              <span>Up to ₹{displayMaxPrice.toFixed(2)}</span>
            </div>
            <input
              type="range"
              className="price-slider"
              min="0"
              max={priceLimit}
              step="10"
              value={maxPrice}
              onChange={(e) => setMaxPrice(Number(e.target.value))}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
                        <h4>Filter By Brand</h4>

            {uniqueBrands?.map((brand) => (
              <label key={brand}>
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  checked={selectedBrands.includes(brand)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedBrands((prev) => [...prev, brand]);
                    } else {
                      setSelectedBrands((prev) =>
                        prev.filter((b) => b !== brand),
                      );
                    }
                  }}
                />
                {brand}
              </label>
            ))}
          </div>
          <div className="discount-filter">
            <h4>Filter By Discount</h4>

            <div className="discount-range">
              <span>{minDiscount}% and above</span>
            </div>
            <input
              type="range"
              className="discount-slider"
              min="0"
              max="80"
              step="5"
              value={minDiscount}
              onChange={(e) => setMinDiscount(Number(e.target.value))}
            />
          </div>

          <button
            className="clear-filters"
            onClick={() => {
              setSelectedCategory(null);
              setSelectedModels([]);
              setMaxPrice(priceLimit);
              setSelectedBrands([]);
              setMinDiscount(0)
            }}
          >
            Clear All Filters
          </button>
        </div>

      {/* PRODUCT GRID WITH SCROLL BUTTONS */}
      <div className="products-section">
        {/* {filteredProducts.length > 0 && (
          <>
            <button className="scroll-btn left" onClick={scrollLeft}>
              <FaArrowLeft />
            </button>
            <button className="scroll-btn right" onClick={scrollRight}>
              <FaArrowRight />
            </button>
          </>
        )} */}

        {loading && (
          <div className="loading-container">
            <Spin size="large" />
          </div>
        )}

        {!loading && filteredProducts.length === 0 && (
          <div className="no-products">
            <p>No products found.</p>
          </div>
        )}

        <div className="product-grid" ref={productGridRef}>
          {filteredProducts.map((p) => {
            const discount = p.discount || 0;
            const mrp = p.mrp || 0;
            const stock = p.stock || 0;
            const qty =
              itemList.find(
                (item) => String(item.productId) === String(p.productid),
              )?.count || 0;
            const minorderqty = p.minorderqty || p.dtl?.[0]?.minorderqty || 1;
            const savedPurchaseData = getSavedCartPurchaseData(p.productid);
            const purchaseType = savedPurchaseData?.purchaseType || "piece";

            return (
              <div key={p.productid} className="product-card">
                {isLoggedIn && discount > 0 && <div className="discount">{discount}%</div>}

                {/* WISHLIST ICON */}
                <div className="bestsellers-actions">
                  <button
                    type="button"
                    onClick={() =>
                      wishlist[p.productid]
                        ? handleDeleteWishList(p.productid)
                        : handleAddToWishList(p.productid)
                    }
                  >
                    {wishlist[p.productid] ? (
                      <FaHeart color="red" />
                    ) : (
                      <FaRegHeart />
                    )}
                  </button>
                </div>

                <img
                  src={p.image1?.trim() || p.image2?.trim() || p.image3?.trim() || noimage}
                  alt={p.modelno}
                  onError={(e) => (e.target.src = noimage)}
                  onClick={() => goToProductDetail(p.productid)}
                />

                <p className="category">{p.brand}</p>
                <p className="category">{p.category}</p>
                <span className="category1">{p.modelno}</span>

                <div className="price-section">
                  <div className="price-row" style={{ flexDirection: "column-reverse", alignItems: "flex-start", gap: "4px" }}>
                    {!isLoggedIn ? (
                      <span className="new" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                        <FaArrowDown />
                        ₹{Number(mrp || 0).toFixed(2)}
                      </span>
                    ) : (
                      <>
                        <span className="new">
                          {Number(p.netrate || p.dtl?.[0]?.netrate || 0) > 0
                            ? `Rs. ${Number(p.netrate || p.dtl?.[0]?.netrate).toFixed(2)}`
                            : `₹${discount ? Number(mrp - (mrp * discount) / 100 || 0).toFixed(2) : Number(mrp || 0).toFixed(2)}`}
                        </span>
                        {discount > 0 && Number(p.netrate || p.dtl?.[0]?.netrate || 0) <= 0 && (
                          <span className="old1" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            <FaArrowDown /> ₹{Number(mrp || 0).toFixed(2)}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {stock <= 0 ? (
                  <button
                    style={{
                      backgroundColor: "#e0e0e0",
                      color: "#777",
                      borderRadius: "25px",
                      padding: "7px 14px",
                      fontWeight: "600",
                      width: "100%",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => handleNotifyMe(p.productid)}
                  >
                    Notify Me
                  </button>
                ) : qty > 0 ? (
                  <CartQuantityControl
                    qty={qty}
                    minQty={getMinimumPurchaseQuantity(p, purchaseType)}
                    step={purchaseType !== "piece" ? getPurchaseQuantityStep(p, purchaseType) : undefined}
                    stock={stock}
                    purchaseType={purchaseType}
                    product={p}
                    onChange={(newQty) => handleCartQtyChange(p.productid, newQty)}
                    className="qty-box"
                  />
                ) : (
                  <button
                    style={{
                      backgroundColor: "#005487",
                      color: "#fff",
                      borderRadius: "25px",
                      padding: "7px 14px",
                      fontWeight: "600",
                      width: "100%",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => openPurchaseModal(p)}
                  >
                    ADD TO CART
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {authModal}

      <PurchaseOptionsModal
        isOpen={showPurchaseModal}
        product={pendingPurchaseProduct}
        onClose={() => {
          setShowPurchaseModal(false);
          setPendingPurchaseProduct(null);
        }}
        onConfirm={confirmPurchaseType}
      />
    </div>
  );
}

export default ShopByCategory;
